/* Label Rutba — storefront behaviour (built from the Sunnah Blends script) (no dependencies).
   Reveal animations, header, drawer, search, product forms, AJAX cart, small UX helpers. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var routes = window.LR_ROUTES || { cart: '/cart', cartAdd: '/cart/add', root: '/' };
  var money = window.LR_MONEY || '₹{{amount}}';
  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };

  function formatMoney(cents) {
    var v = (cents / 100).toFixed(2), parts = v.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = whole, withDec = whole + '.' + parts[1];
    return money.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec).replace(/\{\{\s*amount\s*\}\}/, parts[1] === '00' ? noDec : withDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDec);
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var els = $$('[data-reveal], .lr-draw, .lr-step');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- header ---------- */
  function initHeader() {
    var header = $('.lr-header');
    if (!header) return;
    var lastY = window.scrollY, ticking = false;
    function measure() { root.style.setProperty('--lr-header-h', header.offsetHeight + 'px'); }
    function update() {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 40);
      if (!root.classList.contains('lr-lock')) header.classList.toggle('is-hidden', y > 500 && y > lastY + 4);
      if (y < lastY - 4 || y < 500) header.classList.remove('is-hidden');
      lastY = y; ticking = false;
    }
    measure(); update();
    window.addEventListener('resize', measure);
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  }

  /* ---------- overlays: drawer + search ---------- */
  function initOverlays() {
    var lastFocus = null;
    function open(el) {
      if (!el) return;
      lastFocus = doc.activeElement;
      el.classList.add('is-open'); el.removeAttribute('aria-hidden');
      root.classList.add('lr-lock');
      var f = $('input, a, button', el); if (f) setTimeout(function () { f.focus(); }, 80);
      $$('[data-lr-open="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    }
    function close(el) {
      if (!el || !el.classList.contains('is-open')) return;
      el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
      root.classList.remove('lr-lock');
      $$('[data-lr-open="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastFocus) lastFocus.focus();
    }
    doc.addEventListener('click', function (e) {
      var o = e.target.closest('[data-lr-open]');
      if (o) { e.preventDefault(); open(doc.getElementById(o.getAttribute('data-lr-open'))); return; }
      var c = e.target.closest('[data-lr-close]');
      if (c) { e.preventDefault(); close(c.closest('.lr-drawer, .lr-search')); }
    });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.lr-drawer.is-open, .lr-search.is-open').forEach(close); });
  }

  /* ---------- hero: sparks + gentle parallax ---------- */
  function initHero() {
    var hero = $('.lr-hero');
    if (!hero || reduce) return;
    var art = $('.lr-hero__art', hero);
    for (var i = 0; i < 14; i++) {
      var s = doc.createElement('span');
      s.className = 'lr-hero__spark';
      s.style.left = (45 + Math.random() * 50) + '%';
      s.style.top = (40 + Math.random() * 50) + '%';
      s.style.animationDelay = (Math.random() * 7) + 's';
      s.style.animationDuration = (5 + Math.random() * 4) + 's';
      hero.appendChild(s);
    }
    var jars = $('.lr-hero__jars', hero);
    window.addEventListener('scroll', function () {
      var y = Math.min(window.scrollY, 900);
      if (jars) jars.style.transform = 'translateY(' + (y * -0.08) + 'px)';
      if (art) art.style.opacity = String(1 - Math.min(y / 900, 0.5));
    }, { passive: true });
  }

  /* ---------- craft journey progress line ---------- */
  function initJourney() {
    $$('.lr-journey__list').forEach(function (list) {
      var bar = $('.lr-journey__line i', list);
      if (!bar) return;
      function upd() {
        var r = list.getBoundingClientRect(), vh = window.innerHeight;
        var p = Math.max(0, Math.min(1, (vh * 0.6 - r.top) / r.height));
        bar.style.setProperty('--p', (p * 100).toFixed(1) + '%');
      }
      upd(); window.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    });
  }

  /* ---------- product forms: variants, quantity, price ---------- */
  function initProductForms() {
    $$('[data-lr-product]').forEach(function (wrap) {
      var data; try { data = JSON.parse($('script[type="application/json"]', wrap).textContent); } catch (e) { return; }
      var form = $('form', wrap), idInput = $('input[name="id"]', wrap);
      function current() {
        var opts = $$('.lr-sizes', wrap).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        return data.variants.filter(function (v) { return opts.every(function (o, i) { return o === null || v.options[i] === o; }); })[0];
      }
      function render() {
        var v = current(); if (!v) return;
        if (idInput) idInput.value = v.id;
        $$('[data-lr-price]', wrap).forEach(function (p) { p.textContent = formatMoney(v.price); });
        $$('[data-lr-compare]', wrap).forEach(function (p) { p.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : ''; });
        $$('[data-lr-add], [data-lr-buynow]', wrap).forEach(function (b) {
          b.disabled = !v.available;
          if (b.hasAttribute('data-lr-add')) { var t = $('span', b) || b; t.textContent = v.available ? (b.getAttribute('data-label') || 'Add to cart') : 'Sold out'; }
        });
        if (wrap.hasAttribute('data-lr-update-url') && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u);
        }
      }
      wrap.addEventListener('change', function (e) { if (e.target.closest('.lr-sizes')) render(); });
      render();
    });
    doc.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lr-qty]');
      if (!b) return;
      var input = $('input', b.parentNode), n = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, n + (b.getAttribute('data-lr-qty') === '+' ? 1 : -1));
    });
  }

  /* ---------- cart (AJAX with graceful fallback) ---------- */
  function setCount(n) {
    $$('.lr-cart-count').forEach(function (c) {
      c.textContent = n; c.setAttribute('data-count', n);
      c.classList.add('is-bump'); setTimeout(function () { c.classList.remove('is-bump'); }, 400);
    });
  }
  function toast(msg, img) {
    var t = $('.lr-toast');
    if (!t) return;
    $('p', t).textContent = msg;
    var im = $('img', t); if (im) { if (img) { im.src = img; im.hidden = false; } else im.hidden = true; }
    t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 4200);
  }
  function initCart() {
    doc.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-lr-cart-form]');
      if (!form || !window.fetch) return;
      e.preventDefault();
      var buyNow = e.submitter && e.submitter.hasAttribute('data-lr-buynow');
      var btn = e.submitter || $('[data-lr-add]', form);
      if (btn) btn.classList.add('is-loading');
      fetch(routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (item) {
          if (buyNow) { window.location.href = '/checkout'; return; }
          toast((item.product_title || 'Added') + ' added to your cart', item.image);
          return fetch(routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
        })
        .catch(function (err) { toast((err && (err.description || err.message)) || 'Sorry, that could not be added. Please try again.'); })
        .then(function () { if (btn) btn.classList.remove('is-loading'); });
    });
  }

  /* ---------- gallery ---------- */
  function initGallery() {
    $$('.lr-gallery').forEach(function (g) {
      var imgs = $$('.lr-gallery__main img', g), thumbs = $$('.lr-gallery__thumbs button', g);
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          imgs.forEach(function (im, j) { im.classList.toggle('is-active', i === j); });
          thumbs.forEach(function (x, j) { x.classList.toggle('is-active', i === j); x.setAttribute('aria-current', i === j ? 'true' : 'false'); });
        });
      });
    });
  }

  /* ---------- sticky buy bar (product) ---------- */
  function initSticky() {
    var bar = $('.lr-sticky-buy'), target = $('[data-lr-sticky-target]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    doc.body.classList.add('lr-has-sticky');
    new IntersectionObserver(function (en) {
      var below = en[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-on', !en[0].isIntersecting && below);
    }).observe(target);
    var go = $('button', bar);
    if (go) go.addEventListener('click', function () { var b = $('[data-lr-add]', target.closest('[data-lr-product]') || doc); if (b) b.click(); });
  }

  /* ---------- batch lookup (lab reports) ---------- */
  function initBatch() {
    var q = new URLSearchParams(window.location.search).get('batch');
    if (!q) return;
    q = q.trim().toUpperCase();
    var hit = null;
    $$('[data-batch]').forEach(function (row) { if (row.getAttribute('data-batch').toUpperCase() === q) { row.classList.add('is-match'); hit = row; } });
    var msg = $('[data-lr-batch-msg]');
    if (msg) msg.textContent = hit ? 'Batch ' + q + ' found below.' : 'We could not find batch ' + q + ' yet. New reports are added as each batch is tested.';
    if (hit) setTimeout(function () { hit.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }, 400);
  }

  /* ---------- back to top ---------- */
  function initTop() {
    var b = $('.lr-top'); if (!b) return;
    window.addEventListener('scroll', function () { b.classList.toggle('is-on', window.scrollY > 900); }, { passive: true });
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
  }

  function init() { initReveal(); initHeader(); initOverlays(); initHero(); initJourney(); initProductForms(); initCart(); initGallery(); initSticky(); initBatch(); initTop(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
  doc.addEventListener('shopify:section:load', function () { initReveal(); initProductForms(); initGallery(); initJourney(); });
})();

/* ---------- Label Rutba additions: hero slideshow, side-thumb gallery with zoom, filters, size-chart link ---------- */
(function () {
  var doc = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function each(sel, fn, ctx) { Array.prototype.forEach.call((ctx || doc).querySelectorAll(sel), fn); }

  function slides() {
    each('[data-lr-slides]', function (root) {
      var items = root.querySelectorAll('.lr-slide'), dots = root.querySelectorAll('.lr-slides__dots button');
      if (items.length < 2) return;
      var i = 0, ms = (parseInt(root.getAttribute('data-interval'), 10) || 7) * 1000, timer;
      function show(n) {
        i = (n + items.length) % items.length;
        Array.prototype.forEach.call(items, function (s, k) { s.classList.toggle('is-active', k === i); });
        Array.prototype.forEach.call(dots, function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
      function play() { if (!reduce) { clearInterval(timer); timer = setInterval(function () { show(i + 1); }, ms); } }
      Array.prototype.forEach.call(dots, function (d, k) { d.addEventListener('click', function () { show(k); play(); }); });
      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', play);
      root.addEventListener('focusin', function () { clearInterval(timer); });
      play();
    });
  }

  function gallery() {
    each('[data-lr-pgal]', function (g) {
      var main = g.querySelector('.lr-pgal__main'), imgs = main.querySelectorAll('img'), thumbs = g.querySelectorAll('.lr-pgal__thumbs button');
      Array.prototype.forEach.call(thumbs, function (t, k) {
        t.addEventListener('click', function () {
          main.classList.remove('is-zoom');
          Array.prototype.forEach.call(imgs, function (im, j) { im.classList.toggle('is-active', j === k); });
          Array.prototype.forEach.call(thumbs, function (x, j) { x.setAttribute('aria-current', j === k ? 'true' : 'false'); });
        });
      });
      main.addEventListener('click', function (e) {
        var on = main.classList.toggle('is-zoom'), active = main.querySelector('img.is-active');
        if (on && active) zoomAt(e, active);
      });
      main.addEventListener('mousemove', function (e) { var a = main.querySelector('img.is-active'); if (main.classList.contains('is-zoom') && a) zoomAt(e, a); });
      main.addEventListener('mouseleave', function () { main.classList.remove('is-zoom'); });
      function zoomAt(e, im) {
        var r = main.getBoundingClientRect();
        im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      }
    });
  }

  function filters() {
    each('[data-lr-filters]', function (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"], select')) submit();
      });
      each('.lr-price-range input', function (inp) { inp.addEventListener('change', submit); }, form);
      function submit() {
        var params = new URLSearchParams(new FormData(form));
        Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
        window.location.search = params.toString();
      }
      var tg = form.querySelector('[data-lr-filter-toggle]');
      if (tg) tg.addEventListener('click', function () {
        var box = form.querySelector('.lr-filters'), open = box.classList.toggle('is-open');
        tg.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function chartLink() {
    doc.addEventListener('click', function (e) {
      var a = e.target.closest('[data-lr-chart]'); if (!a) return;
      var d = doc.getElementById('lr-size-chart'); if (!d) return;
      e.preventDefault(); d.open = true; d.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    });
  }

  function start() { slides(); gallery(); filters(); chartLink(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
})();
